import { render, staticRenderFns } from "./HelpdeskCategoryCard.vue?vue&type=template&id=16e33a23&scoped=true"
import script from "./HelpdeskCategoryCard.vue?vue&type=script&lang=ts"
export * from "./HelpdeskCategoryCard.vue?vue&type=script&lang=ts"
import style0 from "./HelpdeskCategoryCard.vue?vue&type=style&index=0&id=16e33a23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e33a23",
  null
  
)

export default component.exports